(() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __esm = (fn, res, err) => function __init() {
    if (err) throw err[0];
    try {
      return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
    } catch (e) {
      throw err = [e], e;
    }
  };
  var __commonJS = (cb, mod) => function __require() {
    try {
      return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    } catch (e) {
      throw mod = 0, e;
    }
  };

  // Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/services/shopify.js
  var LATENCY, delay, ShopifyAPI;
  var init_shopify = __esm({
    "Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/services/shopify.js"() {
      LATENCY = 300;
      delay = () => new Promise((resolve) => setTimeout(resolve, LATENCY));
      ShopifyAPI = {
        /**
         * Mock GET /cart.js
         * @param {Object} currentCartState - The current local cart state.
         * @returns {Promise<Object>} The simulated Shopify cart response.
         */
        async getCart(currentCartState) {
          await delay();
          return { ...currentCartState };
        },
        /**
         * Mock POST /cart/add.js
         * @param {Object} currentCartState - The current local cart state.
         * @param {Object} item - The item details: { id, quantity, properties }
         * @returns {Promise<Object>} The updated item response.
         */
        async addToCart(currentCartState, item) {
          await delay();
          return {
            id: item.id,
            quantity: item.quantity,
            title: item.title,
            price: item.price,
            final_price: item.price,
            line_price: item.price * item.quantity,
            featured_image: {
              url: item.image
            },
            variant_options: [item.variantLabel]
          };
        },
        /**
         * Mock POST /cart/change.js
         * @param {Object} currentCartState - The current local cart state.
         * @param {string} lineKey - The line identifier.
         * @param {number} quantity - The target quantity.
         * @returns {Promise<Object>} The updated cart response.
         */
        async changeQuantity(currentCartState, lineKey, quantity) {
          await delay();
          return { ...currentCartState };
        }
      };
    }
  });

  // Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/services/checkout.js
  var CheckoutService;
  var init_checkout = __esm({
    "Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/services/checkout.js"() {
      CheckoutService = {
        /**
         * Initiate Checkout Redirect.
         * Compiles items into a Shopify checkout link format:
         * e.g., https://your-store.myshopify.com/cart/362541258:1,362541259:2
         * @param {Array} items - List of active cart items.
         */
        startCheckout(items) {
          if (items.length === 0) {
            alert("Your cart is empty.");
            return;
          }
          console.log("Initiating checkout pipeline for items:", items);
          const checkoutSummary = items.map(
            (item) => `\u2022 ${item.title} (${item.variantLabel}) - Qty: ${item.quantity} - \u20B9${(item.price * item.quantity).toLocaleString()}`
          ).join("\n");
          const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
          alert(
            `\u{1F6D2} [Shopify Direct Checkout Simulator]

Proceeding to Shopify secure checkout with the following payload:

${checkoutSummary}

Total Value: \u20B9${total.toLocaleString()}

Redirecting you to secure checkout...`
          );
        }
      };
    }
  });

  // Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/services/cart.js
  function broadcast() {
    listeners.forEach((callback) => callback({ ...state }));
  }
  function persistCart() {
    try {
      localStorage.setItem("mr_cart_state", JSON.stringify(state));
    } catch (e) {
      console.error("Failed to save cart to localStorage:", e);
    }
  }
  function recalculateTotals() {
    let count = 0;
    let price = 0;
    state.items.forEach((item) => {
      count += item.quantity;
      price += item.price * item.quantity;
    });
    state.total_price = price;
    state.item_count = count;
    persistCart();
  }
  var state, listeners, Cart;
  var init_cart = __esm({
    "Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/services/cart.js"() {
      init_shopify();
      init_checkout();
      state = {
        items: [],
        total_price: 0,
        item_count: 0
      };
      listeners = [];
      Cart = {
        /**
         * Initialize Cart state from LocalStorage.
         */
        init() {
          try {
            const saved = localStorage.getItem("mr_cart_state");
            if (saved) {
              const parsed = JSON.parse(saved);
              state.items = parsed.items || [];
              state.total_price = parsed.total_price || 0;
              state.item_count = parsed.item_count || 0;
            }
          } catch (e) {
            console.warn("Failed to load cart from localStorage, starting empty:", e);
          }
          broadcast();
        },
        /**
         * Subscribe to Cart state changes.
         * @param {Function} callback - Function called with updated state.
         */
        subscribe(callback) {
          listeners.push(callback);
          callback({ ...state });
          return () => {
            const idx = listeners.indexOf(callback);
            if (idx !== -1) listeners.splice(idx, 1);
          };
        },
        /**
         * Add a product package to the cart.
         * @param {Object} product - Product data object.
         * @param {number} pricingIndex - Selected pricing package index.
         * @param {number} quantity - Quantity to add.
         */
        async add(product, pricingIndex, quantity = 1) {
          const pkg = product.pricing[pricingIndex];
          const itemId = `${product.id}-${pkg.months}`;
          const existingIndex = state.items.findIndex((item) => item.id === itemId);
          const itemPayload = {
            id: itemId,
            product_id: product.id,
            title: product.name,
            variantLabel: `${pkg.months} Month Pack`,
            price: pkg.price,
            quantity,
            image: product.images.transparent
          };
          await ShopifyAPI.addToCart(state, itemPayload);
          if (existingIndex !== -1) {
            state.items[existingIndex].quantity += quantity;
          } else {
            state.items.push(itemPayload);
          }
          recalculateTotals();
          broadcast();
          this.openDrawer();
        },
        /**
         * Update item quantity.
         * @param {string} itemId - Item unique key.
         * @param {number} quantity - Target quantity.
         */
        async update(itemId, quantity) {
          const existingIndex = state.items.findIndex((item) => item.id === itemId);
          if (existingIndex === -1) return;
          if (quantity <= 0) {
            await this.remove(itemId);
            return;
          }
          await ShopifyAPI.changeQuantity(state, itemId, quantity);
          state.items[existingIndex].quantity = quantity;
          recalculateTotals();
          broadcast();
        },
        /**
         * Remove item from cart.
         * @param {string} itemId - Item unique key.
         */
        async remove(itemId) {
          const existingIndex = state.items.findIndex((item) => item.id === itemId);
          if (existingIndex === -1) return;
          await ShopifyAPI.changeQuantity(state, itemId, 0);
          state.items.splice(existingIndex, 1);
          recalculateTotals();
          broadcast();
        },
        /**
         * Open the Cart Drawer in the UI.
         */
        openDrawer() {
          const overlay = document.getElementById("cart-overlay");
          if (overlay) {
            overlay.classList.add("open");
            window.AppState.cart.isOpen = true;
          }
        },
        /**
         * Close the Cart Drawer in the UI.
         */
        closeDrawer() {
          const overlay = document.getElementById("cart-overlay");
          if (overlay) {
            overlay.classList.remove("open");
            window.AppState.cart.isOpen = false;
          }
        },
        /**
         * Returns current state object.
         * @returns {Object}
         */
        get() {
          return { ...state };
        },
        /**
         * Initiate Shopify-ready checkout redirect.
         */
        checkout() {
          CheckoutService.startCheckout(state.items);
        }
      };
    }
  });

  // Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/products.js
  var products;
  var init_products = __esm({
    "Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/products.js"() {
      products = {
        pickupBottle: {
          id: "pickup-bottle",
          name: "Pick Up Bottle",
          category: "Men's Wellness / Daily Health Supplement",
          subtitle: `Men's <span class="text-gradient">Vitality Formula</span>`,
          typingPhrases: ["Himalayan Shilajit Extract", "100% Ayurvedic Vigor", "Cellular Energy Booster"],
          description: "A premium 100% Ayurvedic daily supplement designed to enhance stamina, cellular energy, and physical performance. Built on pure adaptogens like Himalayan Shilajit and Ashwagandha to support long-term male wellness safely.",
          theme: {
            accentColor: "#D8B369",
            accentColorRgb: "216, 179, 105",
            accentGradient: "linear-gradient(135deg, #E9CE94, #C9A24B 50%, #8A6A3A 100%)",
            forestBg: "#12291E",
            inkBg: "#0A1712",
            badgeColor: "#C9A24B",
            name: "gold"
          },
          sections: {
            hero: true,
            reels: true,
            ingredients: true,
            reviews: true,
            comparison: true,
            faq: true
          },
          images: {
            hero: "assets/images/bottle-hero.webp",
            transparent: "assets/images/bottle-transparent.webp",
            product: "assets/images/bottle-product.webp"
          },
          pricing: [
            { months: 1, label: "1 Month Pack", price: 799, comparePrice: 999, discountLabel: "Save 20%", isBestValue: false },
            { months: 3, label: "3 Month Pack", price: 1999, comparePrice: 2997, discountLabel: "Save 33%", isBestValue: true },
            { months: 6, label: "6 Month Pack", price: 3599, comparePrice: 5994, discountLabel: "Save 40%", isBestValue: false }
          ],
          benefits: [
            { title: "Boosts Stamina & Drive", description: "Supports physical strength and cellular energy delivery." },
            { title: "Supports Performance", description: "Helps enhance vigor, physical performance, and mental confidence." },
            { title: "100% Ayurvedic & Safe", description: "Free from synthetic stimulants, heavy metals, or added steroids." },
            { title: "Lab Tested Quality", description: "Every batch is tested for absolute purity, potency, and safety." }
          ],
          ingredients: [
            {
              name: "Himalayan Shilajit",
              role: "Vigor & Stamina",
              compound: "60% Fulvic Acid",
              description: "Sourced from high-altitude Himalayan rock fissures. It delivers raw minerals and fulvic acid directly to cells, accelerating mitochondrial ATP production and supporting long-term stamina.",
              highlights: ["\u26A1 ATP Production", "\u{1F331} Pure Mineral Resin"],
              image: "assets/images/Himalayan Shilajit.webp",
              svg: `<svg viewBox="0 0 200 200" class="ing-svg"><defs><radialGradient id="shilajit-glow" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#E9CE94" stop-opacity="0.4"/><stop offset="100%" stop-color="#0A1712" stop-opacity="0"/></radialGradient></defs><circle cx="100" cy="100" r="90" fill="url(#shilajit-glow)" class="anim-pulse-glow" /><g class="anim-float-path"><path d="M70 120 L90 60 L130 50 L150 100 L130 150 L80 140 Z" fill="#2A2A2A" stroke="#E9CE94" stroke-width="2.5" /><path d="M80 110 L95 70 L120 65 L135 100 L120 135 L90 125 Z" fill="#1A1A1A" opacity="0.85" /><path d="M90 60 L110 80 M130 50 L120 90 M150 100 L130 115" stroke="#C9A24B" stroke-width="3" stroke-linecap="round" /></g></svg>`
            },
            {
              name: "Ashwagandha Root",
              role: "Cortisol & Strength",
              compound: "5% Withanolides (KSM-66)",
              description: "A powerful adaptogen that reduces stress, lowers cortisol levels, and is clinically proven to support muscle mass recovery, physical energy, and strength gains.",
              highlights: ["\u{1F9E0} Stress Lowering", "\u{1F4AA} Muscle Recovery"],
              image: "assets/images/Ashwagandha Root 2.webp",
              svg: `<svg viewBox="0 0 200 200" class="ing-svg"><defs><radialGradient id="ashwa-glow" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#D8B369" stop-opacity="0.35"/><stop offset="100%" stop-color="#0A1712" stop-opacity="0"/></radialGradient></defs><circle cx="100" cy="100" r="90" fill="url(#ashwa-glow)" class="anim-pulse-glow" /><g class="anim-float-path"><path d="M100 40 Q95 70 85 100 T75 160" fill="none" stroke="#E9D5B8" stroke-width="6" stroke-linecap="round" /><path d="M100 45 Q105 80 115 110 T125 155" fill="none" stroke="#E9D5B8" stroke-width="5" stroke-linecap="round" /><path d="M90 90 Q70 110 60 140" fill="none" stroke="#C9A24B" stroke-width="3" stroke-linecap="round" /><path d="M110 100 Q130 120 145 135" fill="none" stroke="#C9A24B" stroke-width="3" stroke-linecap="round" /><path d="M100 40 C90 20 100 10 100 10 C100 10 110 20 100 40" fill="#5C8570" stroke="#D8B369" stroke-width="1.5" /></g></svg>`
            },
            {
              name: "Safed Musli",
              role: "Muscle & Vigor",
              compound: "40% Saponins",
              description: "Highly valued for its nourishing saponins. It supports lean muscle development, aids cellular recovery, and serves as a natural energizer for vital functions.",
              highlights: ["\u{1F3CB}\uFE0F Lean Muscle", "\u{1F50B} Vitality Restore"],
              image: "assets/images/Safed Musli.webp",
              svg: `<svg viewBox="0 0 200 200" class="ing-svg"><defs><radialGradient id="musli-glow" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#5C8570" stop-opacity="0.4"/><stop offset="100%" stop-color="#0A1712" stop-opacity="0"/></radialGradient></defs><circle cx="100" cy="100" r="90" fill="url(#musli-glow)" class="anim-pulse-glow" /><g class="anim-float-path"><path d="M100 30 Q90 90 95 160" fill="none" stroke="#F7F2E6" stroke-width="5" stroke-linecap="round" /><path d="M100 30 Q80 80 75 150" fill="none" stroke="#F7F2E6" stroke-width="4" stroke-linecap="round" /><path d="M100 30 Q120 80 125 150" fill="none" stroke="#F7F2E6" stroke-width="4" stroke-linecap="round" /></g></svg>`
            },
            {
              name: "Kalinga Beej",
              role: "Absorption Boost",
              compound: "Alkaloids & Minerals",
              description: "Traditional seeds rich in active alkaloids. It optimizes gastrointestinal absorption, ensuring all other Ayurvedic botanicals are fully absorbed into the bloodstream.",
              highlights: ["\u2728 2x Bio-Availability", "\u{1F52C} Gut Synergy"],
              image: "assets/images/Kalinga Beej.webp",
              svg: `<svg viewBox="0 0 200 200" class="ing-svg"><defs><radialGradient id="kalinga-glow" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#E9D5B8" stop-opacity="0.35"/><stop offset="100%" stop-color="#0A1712" stop-opacity="0"/></radialGradient></defs><circle cx="100" cy="100" r="90" fill="url(#kalinga-glow)" class="anim-pulse-glow" /><g class="anim-spin-ring"><ellipse cx="80" cy="90" rx="15" ry="8" transform="rotate(-30 80 90)" fill="#C9A24B" stroke="#E9D5B8" stroke-width="1.5" /><ellipse cx="120" cy="85" rx="18" ry="10" transform="rotate(20 120 85)" fill="#A07D3E" stroke="#E9D5B8" stroke-width="1.5" /><ellipse cx="100" cy="120" rx="16" ry="9" transform="rotate(-10 100 120)" fill="#8A6A3A" stroke="#E9D5B8" stroke-width="1.5" /></g></svg>`
            }
          ],
          directions: [
            "Take 1 capsule twice daily after meals.",
            "Consume with lukewarm water or milk.",
            "For optimal results, use consistently for 60 to 90 days."
          ],
          warnings: [
            "Not intended for individuals under 18 years of age.",
            "Consult a healthcare professional before use if you have any pre-existing health conditions.",
            "Do not exceed the recommended daily dose."
          ],
          faqs: [
            { question: "How long should I take the Pick Up formula?", answer: "We recommend consuming 1 capsule twice daily for 60 to 90 days to allow the adaptogens to build up in your system for sustainable results." },
            { question: "Are there any side effects?", answer: "No, Magic Roots Pick Up is made of 100% natural Ayurvedic herbs and is batch-tested to ensure it is free from heavy metals, synthetic stimulants, and added steroids." },
            { question: "Is this product safe for daily use?", answer: "Yes, it is formulated by Ayurvedic experts as a daily wellness supplement to safely integrate into your routine." }
          ],
          reviews: [
            { name: "Rahul S.", rating: 5, verified: true, date: "2 weeks ago", text: "Felt a noticeable difference in my daily energy levels after 3 weeks. Stamina during gym sessions is definitely up." },
            { name: "Amit K.", rating: 5, verified: true, date: "1 month ago", text: "Excellent product. No side effects or jittery feelings unlike other energy pills. Highly recommend the 3-month bundle." },
            { name: "Vikram P.", rating: 4, verified: true, date: "3 weeks ago", text: "Good stamina booster. Takes a couple of weeks to kick in but it's consistent. Will continue." }
          ],
          comparison: {
            features: [
              { label: "100% Ayurvedic Ingredients", us: true, others: false },
              { label: "No Heavy Metals or Steroids", us: true, others: "Not Guaranteed" },
              { label: "Batch Tested Quality", us: true, others: false },
              { label: "Cellular Stamina (Fulvic Acid)", us: true, others: false }
            ]
          },
          seo: {
            title: "Magic Roots Pick Up | Premium Ayurvedic Men's Vitality",
            description: "Boost your stamina, endurance, and everyday vitality with Magic Roots 100% Ayurvedic Pick Up capsule formula. Lab tested and GMP certified.",
            keywords: ["Ayurvedic stamina", "Shilajit capsules", "Ashwagandha supplement", "men wellness"]
          }
        },
        pickupBlister: {
          id: "pickup-blister",
          name: "Pick Up Blister",
          category: "Men's Wellness / On-Demand Energy Support",
          subtitle: 'On-The-Go <span class="text-gradient">Vitality Strip</span>',
          typingPhrases: ["Fast-Acting Energy Boost", "Travel-Friendly Blister Pack", "Pocket-Safe Vigor"],
          description: "Rise. Perform. Repeat. The same powerful, fast-acting Men's Vitality formula packaged in discreet, travel-friendly blister strips. Ideal for gym bags, travel kits, and keeping active on the go.",
          theme: {
            accentColor: "#D8B369",
            accentColorRgb: "216, 179, 105",
            accentGradient: "linear-gradient(135deg, #E9CE94, #C9A24B 50%, #8A6A3A 100%)",
            forestBg: "#171F29",
            inkBg: "#0D1117",
            badgeColor: "#C9A24B",
            name: "gold"
          },
          sections: {
            hero: true,
            reels: true,
            ingredients: true,
            reviews: true,
            comparison: true,
            faq: true
          },
          images: {
            hero: "assets/images/capsule-hero.webp",
            transparent: "assets/images/capsule-transparent.webp",
            product: "assets/images/capsule-product.webp"
          },
          pricing: [
            { months: 1, label: "Pocket Pack (2 Caps)", price: 299, comparePrice: 399, discountLabel: "Save 25%", isBestValue: false },
            { months: 3, label: "Standard Strip (10 Caps)", price: 799, comparePrice: 1197, discountLabel: "Save 33%", isBestValue: true },
            { months: 6, label: "Bulk Box (30 Caps)", price: 1999, comparePrice: 3594, discountLabel: "Save 44%", isBestValue: false }
          ],
          benefits: [
            { title: "On-Demand Energy Boost", description: "Fast-acting energy extraction optimized for quick physical assimilation." },
            { title: "Travel-Friendly & Discreet", description: "Sleek blister pack fits effortlessly in your wallet, pocket, or kit." },
            { title: "Focused Performance", description: "Designed to provide physical strength and confidence when it matters most." },
            { title: "Zero Synthetic Stimulants", description: "Pure botanical extracts without heavy chemicals or synthetic caffeine spikes." }
          ],
          ingredients: [
            {
              name: "Ashwagandha Extract",
              role: "Vigor & Strength",
              compound: "High-yield Withanolides",
              description: "Provides rapid-acting adaptogenic support that reduces muscular exhaustion and sustains physical capability during intensive physical activities.",
              highlights: ["\u26A1 Rapid-Acting Support", "\u{1F525} High Yield Extract"],
              image: "assets/images/Ashwagandha Root 2.webp",
              svg: `<svg viewBox="0 0 200 200" class="ing-svg"><defs><radialGradient id="ashwa-glow2" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#D8B369" stop-opacity="0.3"/><stop offset="100%" stop-color="#0A1712" stop-opacity="0"/></radialGradient></defs><circle cx="100" cy="100" r="90" fill="url(#ashwa-glow2)" class="anim-pulse-glow" /><g class="anim-float-path"><path d="M100 40 Q95 70 85 100 T75 160" fill="none" stroke="#E9D5B8" stroke-width="6" stroke-linecap="round" /><path d="M100 45 Q105 80 115 110 T125 155" fill="none" stroke="#E9D5B8" stroke-width="5" stroke-linecap="round" /></g></svg>`
            },
            {
              name: "Himalayan Shilajit",
              role: "Cellular Energy",
              compound: "Fulvic Acid Minerals",
              description: "Works to boost oxygen delivery and mineral absorption in muscular tissues, preventing rapid fatigue spikes and providing a clean energy baseline.",
              highlights: ["\u{1FA78} Oxygen Delivery", "\u{1F6E1}\uFE0F Zero Fatigue Spikes"],
              image: "assets/images/Himalayan Shilajit.webp",
              svg: `<svg viewBox="0 0 200 200" class="ing-svg"><defs><radialGradient id="shilajit-glow2" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#E9CE94" stop-opacity="0.35"/><stop offset="100%" stop-color="#0A1712" stop-opacity="0"/></radialGradient></defs><circle cx="100" cy="100" r="90" fill="url(#shilajit-glow2)" class="anim-pulse-glow" /><g class="anim-float-path"><path d="M70 120 L90 60 L130 50 L150 100 L130 150 L80 140 Z" fill="#2A2A2A" stroke="#E9CE94" stroke-width="2" /></g></svg>`
            },
            {
              name: "Safed Musli",
              role: "Physical Vigor",
              compound: "Active Saponins",
              description: "A natural stamina booster that helps nourish internal tissues and supports consistent physical performance under pressure.",
              highlights: ["\u{1F680} Continuous Drive", "\u{1F33F} Pure Botanical"],
              image: "assets/images/Safed Musli.webp",
              svg: `<svg viewBox="0 0 200 200" class="ing-svg"><defs><radialGradient id="musli-glow2" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#5C8570" stop-opacity="0.35"/><stop offset="100%" stop-color="#0A1712" stop-opacity="0"/></radialGradient></defs><circle cx="100" cy="100" r="90" fill="url(#musli-glow2)" class="anim-pulse-glow" /><g class="anim-float-path"><path d="M100 30 Q90 90 95 160" fill="none" stroke="#F7F2E6" stroke-width="5" stroke-linecap="round" /></g></svg>`
            }
          ],
          directions: [
            "Take 1 to 2 capsules with lukewarm water or milk.",
            "Consume 30-45 minutes prior to physical activity.",
            "Do not consume more than 2 capsules in any 24-hour window."
          ],
          warnings: [
            "Do not exceed the daily limit of 2 capsules.",
            "Keep stored in a cool, dry place away from direct sunlight.",
            "Consult a doctor prior to consumption if taking medication."
          ],
          faqs: [
            { question: "How fast does the Blister Pack formula work?", answer: "It is formulated for faster assimilation. We recommend taking 1-2 capsules approximately 30 to 45 minutes prior to exercise or heavy physical activity." },
            { question: "Can I carry this on flights?", answer: "Yes, our blister packs are completely sealed, travel-safe, and meet all airport carry-on regulations." },
            { question: "Does this contain caffeine?", answer: "No. It contains zero added caffeine or chemical stimulants. The energy boost is derived entirely from concentrated adaptogenic herbal extracts." }
          ],
          reviews: [
            { name: "Karan J.", rating: 5, verified: true, date: "1 week ago", text: "Super convenient to keep in my gym bag. Works within 45 minutes of taking. Clean energy boost." },
            { name: "Siddharth M.", rating: 5, verified: true, date: "3 weeks ago", text: "No jittery crash afterwards, which is what I hated about standard pre-workout drinks. The 10-capsule pack is excellent value." }
          ],
          comparison: {
            features: [
              { label: "Travel-Friendly Blister Format", us: true, others: false },
              { label: "No Caffeine Jitters or Crash", us: true, others: false },
              { label: "100% Herbal Extracts", us: true, others: "Uses Synthetic Stimulants" },
              { label: "Discreet Pocket Packaging", us: true, others: false }
            ]
          },
          seo: {
            title: "On-The-Go Men's Vitality Blister Packs | Magic Roots",
            description: "Get clean, fast-acting energy on the go. Magic Roots pocket blister packs are 100% Ayurvedic, travel-friendly stamina booster capsules.",
            keywords: ["pre-workout capsules", "travel supplement", "Shilajit blister pack", "energy on the go"]
          }
        },
        hairZero: {
          id: "hair-zero",
          name: "Hair Zero Cream",
          category: "Personal Care / Skincare / Body Care",
          subtitle: 'Smooth Skin, <span class="text-gradient">Confident You</span>',
          typingPhrases: ["5-Minute Smooth Action", "Aloe Vera Nourishment", "Silky Post-Shave Finish"],
          description: "A fast, dermatologically tested 5-minute hair removal cream that delivers silky-smooth skin without post-shave bumps or irritation. Nourished with skin-cooling Aloe Vera and moisturizing Shea Butter.",
          theme: {
            accentColor: "#5C8570",
            accentColorRgb: "92, 133, 112",
            accentGradient: "linear-gradient(135deg, #B5E2C9, #5C8570 50%, #25412F 100%)",
            forestBg: "#182C22",
            inkBg: "#0D1713",
            badgeColor: "#5C8570",
            name: "jade"
          },
          sections: {
            hero: true,
            reels: true,
            ingredients: true,
            reviews: true,
            comparison: true,
            faq: true
          },
          images: {
            hero: "assets/images/hrc-hero.webp",
            transparent: "assets/images/hrc-transparent.webp",
            product: "assets/images/hrc-product.webp"
          },
          pricing: [
            { months: 1, label: "Single Tube (100ml)", price: 349, comparePrice: 449, discountLabel: "Save 22%", isBestValue: false },
            { months: 3, label: "Double Pack (Save 33%)", price: 599, comparePrice: 898, discountLabel: "Save 33%", isBestValue: true },
            { months: 6, label: "Triple Pack (Save 40%)", price: 799, comparePrice: 1347, discountLabel: "Save 40%", isBestValue: false }
          ],
          benefits: [
            { title: "5-Min Rapid Action", description: "Works rapidly to dissolve hair just below the skin surface." },
            { title: "Silky Smooth Skin", description: "Leaves skin feeling soft and moisturized, preventing dry post-shave scaling." },
            { title: "Gentle & Moisturizing", description: "Infused with cooling botanical extracts to minimize redness and burning." },
            { title: "Dermatologically Approved", description: "Formulated for sensitive skin types. Spatula included in pack." }
          ],
          ingredients: [
            {
              name: "Aloe Vera",
              role: "Soothe & Hydrate",
              compound: "Polysaccharide Gel",
              description: "Cools the skin surface immediately upon contact, locking in deep moisture and preventing chemical warmth during hair dissolving action.",
              highlights: ["\u2744\uFE0F Instant Cooling", "\u{1F4A7} Moisture Lock"],
              image: "assets/images/Aloe Vera.webp",
              svg: `<svg viewBox="0 0 200 200" class="ing-svg"><defs><radialGradient id="aloe-glow" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#5C8570" stop-opacity="0.4"/><stop offset="100%" stop-color="#0A1712" stop-opacity="0"/></radialGradient></defs><circle cx="100" cy="100" r="90" fill="url(#aloe-glow)" class="anim-pulse-glow" /><g class="anim-float-path"><path d="M50 140 C80 130 90 90 120 40 C100 80 80 110 50 140 Z" fill="#4B6E5B" stroke="#D8B369" stroke-width="1.5" /></g></svg>`
            },
            {
              name: "Shea Butter",
              role: "Deep Moisturization",
              compound: "Triterpene Esters",
              description: "Creates a rich lipid barrier on the skin, retaining natural moisture and preventing post-shave dryness, peeling, or irritation.",
              highlights: ["\u{1F6E1}\uFE0F Lipid Barrier", "\u2728 Anti-Irritation"],
              image: "assets/images/Shea Butter.webp",
              svg: `<svg viewBox="0 0 200 200" class="ing-svg"><defs><radialGradient id="shea-glow" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#D8B369" stop-opacity="0.35"/><stop offset="100%" stop-color="#0A1712" stop-opacity="0"/></radialGradient></defs><circle cx="100" cy="100" r="90" fill="url(#shea-glow)" class="anim-pulse-glow" /><g class="anim-float-path"><path d="M70 110 C70 80 100 60 130 80 C140 100 130 130 100 140 C80 140 70 130 70 110 Z" fill="#5A3A22" stroke="#D8B369" stroke-width="1.5" /></g></svg>`
            },
            {
              name: "Vitamin E",
              role: "Skin Regeneration",
              compound: "Tocopherol",
              description: "Nourishes outer skin cells and shields against oxidative stress, supporting rapid tissue cell regeneration after hair removal.",
              highlights: ["\u{1F9EA} Cell Regeneration", "\u{1F6E1}\uFE0F Anti-Oxidant Shield"],
              image: "assets/images/Vitamin E.webp",
              svg: `<svg viewBox="0 0 200 200" class="ing-svg"><defs><radialGradient id="vite-glow" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#C9A24B" stop-opacity="0.4"/><stop offset="100%" stop-color="#0A1712" stop-opacity="0"/></radialGradient></defs><circle cx="100" cy="100" r="90" fill="url(#vite-glow)" class="anim-pulse-glow" /><g class="anim-float-path"><path d="M100 45 C125 85 140 110 140 128 C140 150 122 170 100 170 C78 170 60 150 60 128 C60 110 75 85 100 45 Z" fill="none" stroke="#E9CE94" stroke-width="2.5" /></g></svg>`
            },
            {
              name: "Niacinamide",
              role: "Skin Brightening",
              compound: "Vitamin B3 Active",
              description: "Calms redness, lowers inflammation, and evens out hyperpigmentation on areas where body hair was removed.",
              highlights: ["\u2728 Even Tone", "\u{1F54A}\uFE0F Calms Redness"],
              image: "assets/images/Niacinamide.webp",
              svg: `<svg viewBox="0 0 200 200" class="ing-svg"><defs><radialGradient id="nia-glow" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#5C8570" stop-opacity="0.4"/><stop offset="100%" stop-color="#0A1712" stop-opacity="0"/></radialGradient></defs><circle cx="100" cy="100" r="90" fill="url(#nia-glow)" class="anim-pulse-glow" /><g class="anim-spin-ring"><circle cx="120" cy="80" r="18" fill="#12291E" stroke="#D8B369" stroke-width="3" /><circle cx="80" cy="120" r="12" fill="#12291E" stroke="#5C8570" stroke-width="2" /></g></svg>`
            }
          ],
          directions: [
            "Using the spatula, spread a thick, even layer over the target skin area, fully covering all hair.",
            "Leave the cream on the skin for 5 minutes. Do not exceed 10 minutes total.",
            "Gently scrape away the cream and hair using the curved edge of the spatula.",
            "Rinse skin thoroughly with plain lukewarm water and pat dry gently."
          ],
          warnings: [
            "Always perform a patch test on a small skin patch 24 hours prior to full application.",
            "Do not apply to broken, irritated, sunburnt, or recently waxed skin.",
            "Avoid contact with eyes and face. In case of contact, rinse immediately."
          ],
          faqs: [
            { question: "Is a patch test really necessary?", answer: "Yes. Different skin types react differently. Apply a small amount to your arm and wait 24 hours to ensure zero redness or itching before full application." },
            { question: "Can I use Hair Zero\u2122 on my face?", answer: "No, this formula is optimized for body hair (arms, legs, chest, underarms). Do not apply to the face, eyebrows, or sensitive mucous membranes." },
            { question: "How long does the skin stay smooth?", answer: "Because it dissolves hair just below the surface rather than cutting it at an angle, skin remains smooth up to twice as long as shaving, without rough stubble." }
          ],
          reviews: [
            { name: "Rohan D.", rating: 5, verified: true, date: "3 days ago", text: "No burning smell like other creams. Worked in exactly 6 minutes on my chest hair. Highly recommend." },
            { name: "Priya V.", rating: 5, verified: true, date: "1 week ago", text: "Super smooth. I have sensitive skin, did the patch test first. Aloe Vera in it really cools the skin. Spatula is great." },
            { name: "Aditya S.", rating: 4, verified: true, date: "2 weeks ago", text: "Better than shaving, no cuts or razor bumps. Skin feels soft afterwards. Good packaging." }
          ],
          comparison: {
            features: [
              { label: "Rapid 5-Minute Action", us: true, others: "10-15 Minutes" },
              { label: "Dermatologically Approved", us: true, others: false },
              { label: "Zero Post-Shave Razor Bumps", us: true, others: false },
              { label: "Infused with Aloe & Niacinamide", us: true, others: false }
            ]
          },
          seo: {
            title: "Hair Zero\u2122 5-Min Hair Removal Cream | Magic Roots",
            description: "Experience smooth, bump-free skin with Magic Roots Hair Zero\u2122 Hair Removal Cream. Cooling aloe vera formula with zero razor burns.",
            keywords: ["hair removal cream", "smooth body skin", "aloe hair remover", "no razor bumps"]
          }
        }
      };
    }
  });

  // Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/animations.js
  var AnimationsManager, typewriterTimeout, phraseIdx, charIdx, isDeleting, Typewriter, cloudTimers, cloudReviewIdx, activeBubbles, TestimonialRotator;
  var init_animations = __esm({
    "Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/animations.js"() {
      AnimationsManager = {
        /**
         * Initialize all animations and visual enhancements.
         */
        init() {
          this.setupPageReveals();
          this.setupMouseGlow();
          this.setupLeafParticles();
          this.setupMagneticButtons();
          this.setupBeforeAfterSlider();
          this.setupParallaxImage();
          this.setupScrollSwitcher();
        },
        /**
         * Scroll reveals using Intersection Observer.
         */
        setupPageReveals() {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("reveal-active");
              }
            });
          }, {
            root: null,
            threshold: 0.1,
            rootMargin: "0px 0px -50px 0px"
          });
          document.querySelectorAll(".reveal-on-scroll").forEach((el) => {
            observer.observe(el);
          });
          document.addEventListener("productChanged", () => {
            document.querySelectorAll(".reveal-on-scroll").forEach((el) => {
              observer.observe(el);
            });
          });
        },
        /**
         * Mouse-following gold glow gradient overlay.
         */
        setupMouseGlow() {
          const hero = document.getElementById("hero-section");
          if (!hero) return;
          hero.addEventListener("mousemove", (e) => {
            const rect = hero.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            hero.style.setProperty("--mouse-x", `${x}px`);
            hero.style.setProperty("--mouse-y", `${y}px`);
          });
        },
        /**
         * Floating Ayurvedic leaf particles canvas rendering.
         */
        setupLeafParticles() {
          const canvas = document.getElementById("leaf-particles-canvas");
          if (!canvas) return;
          if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            canvas.style.display = "none";
            return;
          }
          const ctx = canvas.getContext("2d");
          let width = canvas.width = window.innerWidth;
          let height = canvas.height = window.innerHeight;
          window.addEventListener("resize", () => {
            width = canvas.width = window.innerWidth;
            height = canvas.height = window.innerHeight;
          });
          class Leaf {
            constructor() {
              this.reset();
              this.y = Math.random() * height;
            }
            reset() {
              this.x = Math.random() * width;
              this.y = -20;
              this.size = Math.random() * 8 + 6;
              this.speedX = Math.random() * 1 - 0.5;
              this.speedY = Math.random() * 0.8 + 0.4;
              this.rotation = Math.random() * 360;
              this.rotationSpeed = Math.random() * 0.5 - 0.25;
              this.opacity = Math.random() * 0.4 + 0.1;
            }
            update() {
              this.y += this.speedY;
              this.x += this.speedX + Math.sin(this.y / 30) * 0.2;
              this.rotation += this.rotationSpeed;
              if (this.y > height + 20 || this.x < -20 || this.x > width + 20) {
                this.reset();
              }
            }
            draw() {
              ctx.save();
              ctx.translate(this.x, this.y);
              ctx.rotate(this.rotation * Math.PI / 180);
              ctx.globalAlpha = this.opacity;
              ctx.fillStyle = "#D8B369";
              ctx.beginPath();
              ctx.moveTo(0, -this.size);
              ctx.quadraticCurveTo(this.size / 2, 0, 0, this.size);
              ctx.quadraticCurveTo(-this.size / 2, 0, 0, -this.size);
              ctx.fill();
              ctx.restore();
            }
          }
          const leaves = Array.from({ length: 25 }, () => new Leaf());
          function animate() {
            ctx.clearRect(0, 0, width, height);
            leaves.forEach((leaf) => {
              leaf.update();
              leaf.draw();
            });
            requestAnimationFrame(animate);
          }
          animate();
        },
        /**
         * Magnetic buttons coordinates pulls.
         */
        setupMagneticButtons() {
          const buttons = document.querySelectorAll(".btn-primary, .btn-secondary");
          buttons.forEach((btn) => {
            btn.addEventListener("mousemove", (e) => {
              const rect = btn.getBoundingClientRect();
              const x = e.clientX - rect.left - rect.width / 2;
              const y = e.clientY - rect.top - rect.height / 2;
              btn.style.transform = `translate(${x * 0.3}px, ${y * 0.3}px)`;
            });
            btn.addEventListener("mouseleave", () => {
              btn.style.transform = "translate(0px, 0px)";
            });
          });
        },
        /**
         * Before/After comparison slider logic (Hair Zero).
         */
        setupBeforeAfterSlider() {
          const container = document.querySelector(".comparison-slider-container");
          if (!container) return;
          const afterImage = container.querySelector(".slider-after");
          const handle = container.querySelector(".slider-handle");
          let isDragging = false;
          function moveSlider(x) {
            const rect = container.getBoundingClientRect();
            let position = (x - rect.left) / rect.width * 100;
            if (position < 0) position = 0;
            if (position > 100) position = 100;
            afterImage.style.clipPath = `inset(0 0 0 ${position}%)`;
            handle.style.left = `${position}%`;
          }
          container.addEventListener("mousedown", () => isDragging = true);
          window.addEventListener("mouseup", () => isDragging = false);
          container.addEventListener("mousemove", (e) => {
            if (!isDragging) return;
            moveSlider(e.clientX);
          });
          container.addEventListener("touchstart", () => isDragging = true);
          window.addEventListener("touchend", () => isDragging = false);
          container.addEventListener("touchmove", (e) => {
            if (!isDragging) return;
            if (e.touches.length > 0) {
              moveSlider(e.touches[0].clientX);
            }
          });
        },
        /**
         * Subtle mouse-responsive parallax effect on product bottle images.
         */
        setupParallaxImage() {
          const hero = document.getElementById("hero-section");
          if (!hero) return;
          hero.addEventListener("mousemove", (e) => {
            const showcaseImg = hero.querySelector('[data-slot="showcase-img"]');
            if (!showcaseImg) return;
            const rect = hero.getBoundingClientRect();
            const xOffset = (e.clientX - rect.left - rect.width / 2) * 0.03;
            const yOffset = (e.clientY - rect.top - rect.height / 2) * 0.03;
            showcaseImg.style.transform = `translate(${xOffset}px, ${yOffset}px)`;
          });
        },
        /**
         * Captures mouse scroll wheel and swiping on the Hero to slide between products.
         */
        setupScrollSwitcher() {
          const hero = document.getElementById("hero-section");
          if (!hero) return;
          const productsKeys = ["pickupBottle", "pickupBlister", "hairZero"];
          let isTransitioning = false;
          hero.addEventListener("wheel", (e) => {
            if (window.scrollY > 10) return;
            if (isTransitioning) {
              e.preventDefault();
              return;
            }
            const activeBtn = document.querySelector(".switch-pill.active");
            if (!activeBtn) return;
            const currentProductKey = activeBtn.getAttribute("data-product");
            const currentIndex = productsKeys.indexOf(currentProductKey);
            if (e.deltaY > 0) {
              if (currentIndex < productsKeys.length - 1) {
                e.preventDefault();
                const nextProductKey = productsKeys[currentIndex + 1];
                triggerTransition("down", nextProductKey);
              }
            } else if (e.deltaY < 0) {
              if (currentIndex > 0) {
                e.preventDefault();
                const prevProductKey = productsKeys[currentIndex - 1];
                triggerTransition("up", prevProductKey);
              }
            }
          }, { passive: false });
          let touchStartY = 0;
          hero.addEventListener("touchstart", (e) => {
            touchStartY = e.touches[0].clientY;
          }, { passive: true });
          hero.addEventListener("touchmove", (e) => {
            if (window.scrollY > 10 || isTransitioning) return;
            const touchEndY = e.touches[0].clientY;
            const diffY = touchStartY - touchEndY;
            if (Math.abs(diffY) > 50) {
              const activeBtn = document.querySelector(".switch-pill.active");
              if (!activeBtn) return;
              const currentProductKey = activeBtn.getAttribute("data-product");
              const currentIndex = productsKeys.indexOf(currentProductKey);
              if (diffY > 0) {
                if (currentIndex < productsKeys.length - 1) {
                  e.preventDefault();
                  const nextProductKey = productsKeys[currentIndex + 1];
                  triggerTransition("down", nextProductKey);
                }
              } else {
                if (currentIndex > 0) {
                  e.preventDefault();
                  const prevProductKey = productsKeys[currentIndex - 1];
                  triggerTransition("up", prevProductKey);
                }
              }
            }
          }, { passive: false });
          function triggerTransition(direction, targetProductKey) {
            isTransitioning = true;
            const content = hero.querySelector(".hero-content");
            const showcase = hero.querySelector(".hero-showcase");
            if (content) content.classList.add("text-swap");
            const exitClass = direction === "down" ? "slide-up-exit" : "slide-down-exit";
            if (showcase) showcase.classList.add(exitClass);
            setTimeout(() => {
              const targetBtn = document.querySelector(`.switch-pill[data-product="${targetProductKey}"]`);
              if (targetBtn) targetBtn.click();
              if (showcase) {
                showcase.classList.remove(exitClass);
                showcase.classList.add(direction === "down" ? "slide-up-enter" : "slide-down-enter");
                showcase.offsetHeight;
              }
              if (content) {
                content.classList.remove("text-swap");
              }
              setTimeout(() => {
                if (showcase) showcase.classList.remove("slide-up-enter", "slide-down-enter");
                setTimeout(() => {
                  isTransitioning = false;
                }, 400);
              }, 50);
            }, 400);
          }
        }
      };
      typewriterTimeout = null;
      phraseIdx = 0;
      charIdx = 0;
      isDeleting = false;
      Typewriter = {
        /**
         * Start typewriter effect on the target element.
         * @param {Array<string>} phrases - Phrases to cycle through.
         */
        start(phrases) {
          this.stop();
          phraseIdx = 0;
          charIdx = 0;
          isDeleting = false;
          const target = document.getElementById("hero-typing-target");
          if (!target || !phrases || phrases.length === 0) return;
          const type = () => {
            const currentPhrase = phrases[phraseIdx];
            if (isDeleting) {
              target.textContent = currentPhrase.substring(0, charIdx - 1);
              charIdx--;
            } else {
              target.textContent = currentPhrase.substring(0, charIdx + 1);
              charIdx++;
            }
            let delay2 = isDeleting ? 40 : 80;
            if (!isDeleting && charIdx === currentPhrase.length) {
              isDeleting = true;
              delay2 = 1800;
            } else if (isDeleting && charIdx === 0) {
              isDeleting = false;
              phraseIdx = (phraseIdx + 1) % phrases.length;
              delay2 = 300;
            }
            typewriterTimeout = setTimeout(type, delay2);
          };
          type();
        },
        /**
         * Cancel any active typewriter timeouts.
         */
        stop() {
          if (typewriterTimeout) {
            clearTimeout(typewriterTimeout);
            typewriterTimeout = null;
          }
        }
      };
      cloudTimers = [];
      cloudReviewIdx = 0;
      activeBubbles = [];
      TestimonialRotator = {
        /**
         * Start generating review clouds across the blank margins of the full hero section.
         * @param {Array<Object>} reviews - Reviews data list.
         */
        start(reviews) {
          this.stop();
          cloudReviewIdx = 0;
          activeBubbles = [];
          const container = document.getElementById("reviews-cloud-container");
          if (!container || !reviews || reviews.length === 0) return;
          container.innerHTML = "";
          const spawnBubble = () => {
            const rev = reviews[cloudReviewIdx];
            cloudReviewIdx = (cloudReviewIdx + 1) % reviews.length;
            let stars = "";
            for (let i = 0; i < rev.rating; i++) {
              stars += `<svg class="star-icon" viewBox="0 0 24 24" style="width: 10px; height: 10px; fill: var(--color-foil-gold);"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>`;
            }
            const bubble = document.createElement("div");
            bubble.className = "review-bubble";
            const isMobile = window.innerWidth < 768;
            if (isMobile) {
              const onTop = Math.random() > 0.5;
              const topPos = onTop ? Math.floor(Math.random() * 15) + 3 : Math.floor(Math.random() * 15) + 78;
              const leftPos = Math.floor(Math.random() * 50) + 10;
              bubble.style.left = `${leftPos}%`;
              bubble.style.right = "auto";
              bubble.style.top = `${topPos}%`;
            } else {
              const hero = document.getElementById("hero-section");
              const contentEl = document.querySelector(".hero-content");
              const imgEl = document.querySelector('[data-slot="showcase-img"]');
              const heroRect = hero ? hero.getBoundingClientRect() : { width: window.innerWidth, height: 600 };
              const contentRect = contentEl ? contentEl.getBoundingClientRect() : null;
              const imgRect = imgEl ? imgEl.getBoundingClientRect() : null;
              const obstacles = [];
              if (contentRect && hero) {
                obstacles.push({
                  left: contentRect.left - heroRect.left - 25,
                  right: contentRect.right - heroRect.left + 25,
                  top: contentRect.top - heroRect.top - 20,
                  bottom: contentRect.bottom - heroRect.top + 20
                });
              }
              if (imgRect && hero) {
                obstacles.push({
                  left: imgRect.left - heroRect.left - 30,
                  right: imgRect.right - heroRect.left + 30,
                  top: imgRect.top - heroRect.top - 20,
                  bottom: imgRect.bottom - heroRect.top + 20
                });
              }
              const intersects = (r1, r2) => {
                return !(r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top);
              };
              const bubbleWidth = 240;
              const bubbleHeight = 120;
              let bubbleX = 0;
              let bubbleY = 0;
              let positionFound = false;
              for (let attempt = 0; attempt < 20; attempt++) {
                bubbleX = Math.random() * (heroRect.width - bubbleWidth - 40) + 20;
                bubbleY = Math.random() * (heroRect.height - bubbleHeight - 120) + 90;
                const candidate = {
                  left: bubbleX,
                  right: bubbleX + bubbleWidth,
                  top: bubbleY,
                  bottom: bubbleY + bubbleHeight
                };
                let collides = false;
                for (const obs of obstacles) {
                  if (intersects(candidate, obs)) {
                    collides = true;
                    break;
                  }
                }
                if (!collides) {
                  positionFound = true;
                  break;
                }
              }
              if (!positionFound) {
                const onLeft = Math.random() > 0.5;
                bubbleX = onLeft ? 20 : heroRect.width - bubbleWidth - 20;
                bubbleY = 100;
              }
              bubble.style.left = `${bubbleX}px`;
              bubble.style.top = `${bubbleY}px`;
              bubble.style.right = "auto";
            }
            bubble.innerHTML = `
        <div class="review-bubble-stars">${stars}</div>
        <div class="review-bubble-text">"${rev.text.length > 55 ? rev.text.substring(0, 52) + "..." : rev.text}"</div>
        <div class="review-bubble-author">
          <span>\u2014 ${rev.name}</span>
          ${rev.verified ? '<span class="review-bubble-verified">\u2713 Verified</span>' : ""}
        </div>
      `;
            container.appendChild(bubble);
            const inTimeout = setTimeout(() => {
              bubble.classList.add("show");
            }, 50);
            cloudTimers.push(inTimeout);
            activeBubbles.push(bubble);
            if (activeBubbles.length > 2) {
              const oldest = activeBubbles.shift();
              oldest.classList.add("hide");
              const removeTimeout = setTimeout(() => {
                oldest.remove();
              }, 600);
              cloudTimers.push(removeTimeout);
            }
          };
          spawnBubble();
          const staggerTimeout = setTimeout(() => {
            spawnBubble();
          }, 1500);
          cloudTimers.push(staggerTimeout);
          const intervalId = setInterval(() => {
            spawnBubble();
          }, 3e3);
          cloudTimers.push(intervalId);
        },
        /**
         * Clear active intervals and remove all spawned bubbles.
         */
        stop() {
          cloudTimers.forEach((t) => clearTimeout(t));
          cloudTimers.forEach((i) => clearInterval(i));
          cloudTimers = [];
          const container = document.getElementById("reviews-cloud-container");
          if (container) {
            container.innerHTML = "";
          }
        }
      };
    }
  });

  // Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/tabs.js
  function resolveAsset(path) {
    if (!path) return "";
    let filename = path.split("/").pop();
    try {
      filename = decodeURIComponent(filename);
    } catch (e) {
    }
    if (window.ShopifyAssets) {
      if (window.ShopifyAssets[filename]) return window.ShopifyAssets[filename];
      const lower = filename.toLowerCase();
      for (const key in window.ShopifyAssets) {
        if (key.toLowerCase() === lower) return window.ShopifyAssets[key];
      }
    }
    return path;
  }
  function applyTheme(theme) {
    const root = document.documentElement;
    root.style.setProperty("--color-accent", theme.accentColor);
    root.style.setProperty("--color-accent-rgb", theme.accentColorRgb);
    root.style.setProperty("--accent-gradient", theme.accentGradient);
    root.style.setProperty("--color-forest", theme.forestBg);
    root.style.setProperty("--color-ink", theme.inkBg);
    const switcher = document.querySelector(".switcher-pills");
    if (switcher) {
      switcher.className = `switcher-pills theme-${theme.name}`;
    }
  }
  function updateSEO(seo) {
    document.title = seo.title;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", seo.description);
    }
  }
  function renderHero(product) {
    const container = document.getElementById("hero-section");
    if (!container) return;
    if (!product.sections.hero) {
      container.style.display = "none";
      return;
    }
    container.style.display = "";
    container.querySelector('[data-slot="category"]').textContent = product.category;
    container.querySelector('[data-slot="title"]').innerHTML = product.subtitle;
    container.querySelector('[data-slot="description"]').textContent = product.description;
    const highlightsContainer = container.querySelector('[data-slot="highlights"]');
    if (highlightsContainer && product.benefits) {
      const list = product.benefits.slice(0, 3);
      highlightsContainer.innerHTML = list.map((b) => `
      <span class="highlight-item">
        <svg class="highlight-check" viewBox="0 0 24 24">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
        </svg>
        ${b.title}
      </span>
    `).join("");
    }
    const heroShowcase = container.querySelector('[data-slot="showcase-img"]');
    if (heroShowcase) {
      heroShowcase.src = resolveAsset(product.images.transparent);
      heroShowcase.alt = product.name;
    }
  }
  function renderImageStack(imageUrl, quantity) {
    const display = document.getElementById("buy-image-display");
    if (!display) return;
    const oldImages = Array.from(display.querySelectorAll(".product-img"));
    let stackClass = "stack-single";
    let count = 1;
    if (quantity === 3) {
      stackClass = "stack-double";
      count = 2;
    } else if (quantity === 6) {
      stackClass = "stack-triple";
      count = 3;
    }
    oldImages.forEach((img) => img.classList.add("img-exiting"));
    const newImages = [];
    for (let i = 0; i < count; i++) {
      const img = document.createElement("img");
      img.className = "product-img img-entering";
      img.src = resolveAsset(imageUrl);
      display.appendChild(img);
      newImages.push(img);
    }
    display.className = `image-display ${stackClass}`;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        newImages.forEach((img) => img.classList.remove("img-entering"));
      });
    });
    setTimeout(() => {
      oldImages.forEach((img) => img.remove());
    }, 600);
  }
  function renderSelectorBar() {
    const bar = document.getElementById("product-selector");
    if (!bar) return;
    bar.innerHTML = "";
    Object.entries(products).forEach(([key, product]) => {
      const isActive = key === window.AppState.activeProduct;
      const pill = document.createElement("div");
      pill.className = `product-pill ${isActive ? "active" : ""}`;
      pill.innerHTML = `
      <img src="${resolveAsset(product.images.transparent)}" alt="${product.name}">
      <span>${product.name}</span>
    `;
      pill.onclick = () => {
        TabManager.switchProduct(key);
      };
      bar.appendChild(pill);
    });
  }
  function renderBuyBlock(product) {
    const container = document.getElementById("buy-block");
    if (!container) return;
    const catTag = container.querySelector('[data-slot="buy-category-tag"]');
    if (catTag) catTag.textContent = product.category;
    const prodTitle = container.querySelector('[data-slot="buy-product-title"]');
    if (prodTitle) prodTitle.textContent = product.name;
    const prodDesc = container.querySelector('[data-slot="buy-product-desc"]');
    if (prodDesc) prodDesc.textContent = `Select a ${product.name} bundle below to unlock exclusive savings.`;
    const currentBundle = product.pricing[window.AppState.selectedBundleIndex];
    renderImageStack(product.images.transparent, currentBundle ? currentBundle.months : 3);
    const bundleContainer = container.querySelector('[data-slot="bundle-cards"]');
    if (bundleContainer) {
      bundleContainer.innerHTML = "";
      product.pricing.forEach((pkg, index) => {
        const isActive = index === window.AppState.selectedBundleIndex;
        const activeClass = isActive ? "active" : "";
        const bestValueBadge = pkg.isBestValue ? `<div class="badge-tag">Best Value</div>` : "";
        const cardHtml = `
        <div class="bundle-card ${activeClass}" data-bundle-index="${index}">
          ${bestValueBadge}
          <div class="card-left">
            <div class="radio-circle"></div>
            <div class="bundle-info">
              <span class="bundle-name">${pkg.label}</span>
              <span class="bundle-sub">\u20B9${Math.round(pkg.price / pkg.months)} / month \u2014 ${pkg.discountLabel}</span>
            </div>
          </div>
          <div class="bundle-pricing">
            <span class="price-main">\u20B9${pkg.price.toLocaleString()}</span>
            <span class="price-compare">\u20B9${pkg.comparePrice.toLocaleString()}</span>
          </div>
        </div>
      `;
        bundleContainer.insertAdjacentHTML("beforeend", cardHtml);
      });
      bundleContainer.querySelectorAll(".bundle-card").forEach((card) => {
        card.addEventListener("click", () => {
          const index = parseInt(card.getAttribute("data-bundle-index"), 10);
          if (window.AppState.selectedBundleIndex === index) return;
          window.AppState.selectedBundleIndex = index;
          bundleContainer.querySelectorAll(".bundle-card").forEach((c) => c.classList.remove("active"));
          card.classList.add("active");
          const pkg = product.pricing[index];
          renderImageStack(product.images.transparent, pkg.months);
          updateStickyBarPrice(product, index);
        });
      });
    }
  }
  function renderIngredients(product) {
    const container = document.getElementById("ingredients-section");
    if (!container) return;
    if (ingredientActiveAnimationLoop) cancelAnimationFrame(ingredientActiveAnimationLoop);
    if (ingredientInitialSettleTimeout) clearTimeout(ingredientInitialSettleTimeout);
    if (ingredientSequenceInterval) clearInterval(ingredientSequenceInterval);
    container.querySelectorAll(".particle-stage").forEach((stage) => stage.innerHTML = "");
    ingredientParticleInstances = [];
    if (!product.sections.ingredients) {
      container.style.display = "none";
      return;
    }
    container.style.display = "";
    const flexContainer = container.querySelector('[data-slot="ingredients-grid"]');
    if (flexContainer) {
      flexContainer.className = "flex-container";
      flexContainer.innerHTML = "";
      product.ingredients.forEach((ing, index) => {
        const col = document.createElement("div");
        col.className = "flex-col";
        const highlightsHTML = ing.highlights ? ing.highlights.map((h) => `<span class="flex-stat-badge">${h}</span>`).join("") : "";
        col.innerHTML = `
        <!-- Background Slide Frame with Nested Dolly Drift Parent -->
        <div class="tile-bg">
          <div class="tile-bg-inner" style="background-image: url('${resolveAsset(ing.image)}');"></div>
        </div>
        
        <!-- Dark overlay with horizontal fade -->
        <div class="tile-overlay"></div>

        <!-- Collapsed Pillar Layout -->
        <div class="collapsed-wrapper">
          <div class="collapsed-icon">0${index + 1}</div>
          
          <!-- Collapsed Colorful Mini Visual -->
          <div class="collapsed-visual">
            ${ing.svg}
          </div>

          <div class="vertical-title-wrapper">
            <span class="vert-name">${ing.name}</span>
          </div>
        </div>

        <!-- Dynamic Particle Stage -->
        <div class="particle-stage" id="particle-stage-${index}"></div>

        <!-- Expanded Content Grid -->
        <div class="flex-content-grid">
          <div class="flex-visual" id="hero-circle-${index}">
            ${ing.svg}
          </div>
          <div class="flex-info">
            <span class="flex-tag">${ing.role}</span>
            <h3 class="flex-name">${ing.name}</h3>
            <p class="flex-desc">${ing.description}</p>
            
            <div class="flex-features-row">
              <div class="flex-comp-tag">Active: ${ing.compound}</div>
              ${highlightsHTML}
            </div>
          </div>
        </div>
      `;
        col.addEventListener("mouseenter", () => {
          if (col.classList.contains("expanded")) return;
          flexContainer.querySelectorAll(".flex-col").forEach((c) => c.classList.remove("expanded"));
          col.classList.add("expanded");
          scheduleSequentialEmission(col, index, ing.svg);
        });
        col.addEventListener("mouseleave", () => {
          col.classList.remove("expanded");
          if (ingredientActiveAnimationLoop) cancelAnimationFrame(ingredientActiveAnimationLoop);
          if (ingredientInitialSettleTimeout) clearTimeout(ingredientInitialSettleTimeout);
          if (ingredientSequenceInterval) clearInterval(ingredientSequenceInterval);
          const stage = document.getElementById(`particle-stage-${index}`);
          if (stage) stage.innerHTML = "";
          ingredientParticleInstances = [];
        });
        flexContainer.appendChild(col);
      });
      flexContainer.addEventListener("mouseleave", () => {
        flexContainer.querySelectorAll(".flex-col").forEach((c) => {
          c.classList.remove("expanded");
        });
        if (ingredientActiveAnimationLoop) cancelAnimationFrame(ingredientActiveAnimationLoop);
        if (ingredientInitialSettleTimeout) clearTimeout(ingredientInitialSettleTimeout);
        if (ingredientSequenceInterval) clearInterval(ingredientSequenceInterval);
        container.querySelectorAll(".particle-stage").forEach((stage) => stage.innerHTML = "");
        ingredientParticleInstances = [];
      });
    }
  }
  function scheduleSequentialEmission(cardElement, cardIndex, svgCode) {
    if (ingredientActiveAnimationLoop) cancelAnimationFrame(ingredientActiveAnimationLoop);
    if (ingredientInitialSettleTimeout) clearTimeout(ingredientInitialSettleTimeout);
    if (ingredientSequenceInterval) clearInterval(ingredientSequenceInterval);
    const section = document.getElementById("ingredients-section");
    if (section) {
      section.querySelectorAll(".particle-stage").forEach((stage) => stage.innerHTML = "");
    }
    ingredientParticleInstances = [];
    if (window.innerWidth <= 820) return;
    ingredientInitialSettleTimeout = setTimeout(() => {
      if (!cardElement.classList.contains("expanded")) return;
      const stage = document.getElementById(`particle-stage-${cardIndex}`);
      const heroCircle = document.getElementById(`hero-circle-${cardIndex}`);
      if (!stage || !heroCircle) return;
      const cardRect = cardElement.getBoundingClientRect();
      const circleRect = heroCircle.getBoundingClientRect();
      const spawnX = circleRect.left - cardRect.left + circleRect.width / 2;
      const spawnY = circleRect.top - cardRect.top + circleRect.height / 2;
      const maxParticles = 7;
      let releasedCount = 0;
      startPhysicsLoop(cardElement);
      ingredientSequenceInterval = setInterval(() => {
        if (releasedCount >= maxParticles || !cardElement.classList.contains("expanded")) {
          clearInterval(ingredientSequenceInterval);
          return;
        }
        const particle = document.createElement("div");
        particle.className = "mini-particle";
        const size = Math.floor(Math.random() * 16) + 32;
        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;
        particle.style.opacity = "0";
        particle.innerHTML = svgCode;
        stage.appendChild(particle);
        const angle = Math.random() * Math.PI * 2;
        const speed = Math.random() * 0.5 + 0.25;
        const rotSpeed = (Math.random() - 0.5) * 0.8;
        const pObj = {
          el: particle,
          x: spawnX - size / 2,
          y: spawnY - size / 2,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          size,
          rotation: Math.random() * 360,
          vRot: rotSpeed,
          targetOpacity: Math.random() * 0.08 + 0.08
        };
        ingredientParticleInstances.push(pObj);
        requestAnimationFrame(() => {
          particle.style.opacity = pObj.targetOpacity;
        });
        releasedCount++;
      }, 500);
    }, 1e3);
  }
  function startPhysicsLoop(cardElement) {
    function updatePhysics() {
      const stageWidth = cardElement.clientWidth;
      const stageHeight = cardElement.clientHeight;
      ingredientParticleInstances.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        p.rotation += p.vRot;
        if (p.x <= 0) {
          p.x = 0;
          p.vx *= -1;
        } else if (p.x + p.size >= stageWidth) {
          p.x = stageWidth - p.size;
          p.vx *= -1;
        }
        if (p.y <= 0) {
          p.y = 0;
          p.vy *= -1;
        } else if (p.y + p.size >= stageHeight) {
          p.y = stageHeight - p.size;
          p.vy *= -1;
        }
        p.el.style.transform = `translate3d(${p.x}px, ${p.y}px, 0) rotate(${p.rotation}deg)`;
      });
      ingredientActiveAnimationLoop = requestAnimationFrame(updatePhysics);
    }
    ingredientActiveAnimationLoop = requestAnimationFrame(updatePhysics);
  }
  function renderComparison(product) {
    const container = document.getElementById("comparison-section");
    if (!container) return;
    if (!product.sections.comparison) {
      container.style.display = "none";
      return;
    }
    container.style.display = "";
    const tbody = container.querySelector('[data-slot="comparison-body"]');
    if (!tbody) return;
    tbody.innerHTML = "";
    product.comparison.features.forEach((feat) => {
      const usContent = feat.us === true ? `<svg class="icon-status-check" viewBox="0 0 24 24"><path d="M20 6L9 17L4 12"/></svg>` : `<span>${feat.us}</span>`;
      const othersContent = feat.others === false ? `<svg class="icon-status-cross" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>` : `<span>${feat.others}</span>`;
      const rowHtml = `
        <tr>
          <td class="col-feature">${feat.label}</td>
          <td class="col-us">${usContent}</td>
          <td class="col-others">${othersContent}</td>
        </tr>
      `;
      tbody.insertAdjacentHTML("beforeend", rowHtml);
    });
  }
  function renderFAQs(product) {
    const container = document.getElementById("faq-section");
    if (!container) return;
    if (!product.sections.faq) {
      container.style.display = "none";
      return;
    }
    container.style.display = "";
    const faqContainer = container.querySelector('[data-slot="faq-container"]');
    if (faqContainer) {
      faqContainer.innerHTML = "";
      product.faqs.forEach((faq) => {
        const itemHtml = `
        <div class="faq-item">
          <button class="faq-header" aria-expanded="false">
            <span class="faq-question">${faq.question}</span>
            <svg class="faq-icon" viewBox="0 0 24 24">
              <path d="M6 9l6 6 6-6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="faq-content">
            <div class="faq-answer">${faq.answer}</div>
          </div>
        </div>
      `;
        faqContainer.insertAdjacentHTML("beforeend", itemHtml);
      });
    }
  }
  function renderReviews(product) {
    const container = document.getElementById("reviews-section");
    if (!container) return;
    if (!product.sections.reviews) {
      container.style.display = "none";
      return;
    }
    container.style.display = "";
    const grid = container.querySelector('[data-slot="reviews-grid"]');
    if (grid) {
      grid.innerHTML = "";
      product.reviews.forEach((rev) => {
        let stars = "";
        for (let i = 0; i < 5; i++) {
          stars += `<svg class="star-icon" viewBox="0 0 24 24"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>`;
        }
        const cardHtml = `
        <div class="review-card">
          <div class="review-header">
            <div class="reviewer-info">
              <span class="reviewer-name">${rev.name}</span>
              ${rev.verified ? `
              <span class="verified-badge">
                <svg viewBox="0 0 24 24"><path d="M20 6L9 17L4 12" stroke-linecap="round" stroke-linejoin="round"/></svg>
                Verified
              </span>` : ""}
            </div>
            <span class="review-date">${rev.date}</span>
          </div>
          <div class="review-stars">${stars}</div>
          <p class="review-body">"${rev.text}"</p>
        </div>
      `;
        grid.insertAdjacentHTML("beforeend", cardHtml);
      });
    }
  }
  function renderCustomWidgets(product) {
    const container = document.getElementById("interactive-widget-container");
    if (!container) return;
    if (product.id === "hair-zero") {
      container.style.display = "block";
    } else {
      container.style.display = "none";
    }
  }
  function updateStickyBarPrice(product, bundleIndex) {
    const stickyBar = document.getElementById("sticky-buy-bar");
    if (!stickyBar) return;
    const pkg = product.pricing[bundleIndex];
    stickyBar.querySelector('[data-slot="sticky-price"]').textContent = `\u20B9${pkg.price.toLocaleString()}`;
    stickyBar.querySelector('[data-slot="sticky-subtitle"]').textContent = `${pkg.label} \u2014 ${pkg.discountLabel}`;
  }
  function renderStickyBuyBar(product) {
    const stickyBar = document.getElementById("sticky-buy-bar");
    if (!stickyBar) return;
    stickyBar.querySelector('[data-slot="sticky-title"]').textContent = product.name;
    const img = stickyBar.querySelector('[data-slot="sticky-thumb"]');
    if (img) {
      img.src = product.images.transparent;
      img.alt = product.name;
    }
    updateStickyBarPrice(product, window.AppState.selectedBundleIndex);
  }
  var ingredientActiveAnimationLoop, ingredientInitialSettleTimeout, ingredientSequenceInterval, ingredientParticleInstances, TabManager;
  var init_tabs = __esm({
    "Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/tabs.js"() {
      init_products();
      init_animations();
      ingredientActiveAnimationLoop = null;
      ingredientInitialSettleTimeout = null;
      ingredientSequenceInterval = null;
      ingredientParticleInstances = [];
      TabManager = {
        /**
         * Switch the active product page content dynamically.
         * @param {string} productKey - Key of target product (e.g., 'pickupBottle', 'hairZero').
         */
        switchProduct(productKey) {
          const product = products[productKey];
          if (!product) return;
          window.AppState.activeProduct = productKey;
          const bestValueIdx = product.pricing.findIndex((p) => p.isBestValue);
          window.AppState.selectedBundleIndex = bestValueIdx !== -1 ? bestValueIdx : 1;
          document.querySelectorAll(".switch-pill").forEach((btn) => {
            if (btn.getAttribute("data-product") === productKey) {
              btn.classList.add("active");
            } else {
              btn.classList.remove("active");
            }
          });
          document.querySelectorAll(".ingredients-section .product-btn").forEach((btn) => {
            if (btn.getAttribute("data-product") === productKey) {
              btn.classList.add("active");
            } else {
              btn.classList.remove("active");
            }
          });
          applyTheme(product.theme);
          renderHero(product);
          renderBuyBlock(product);
          renderSelectorBar();
          renderIngredients(product);
          renderComparison(product);
          renderFAQs(product);
          renderReviews(product);
          renderCustomWidgets(product);
          renderStickyBuyBar(product);
          updateSEO(product.seo);
          Typewriter.start(product.typingPhrases);
          TestimonialRotator.start(product.reviews);
          document.dispatchEvent(new CustomEvent("productChanged", { detail: { productKey, product } }));
        }
      };
    }
  });

  // Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/faq.js
  var FAQManager;
  var init_faq = __esm({
    "Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/faq.js"() {
      FAQManager = {
        /**
         * Initialize FAQ Accordion listeners using event delegation.
         */
        init() {
          const section = document.getElementById("faq-section");
          if (!section) return;
          section.addEventListener("click", (e) => {
            const header = e.target.closest(".faq-header");
            if (!header) return;
            const item = header.closest(".faq-item");
            const content = item.querySelector(".faq-content");
            const isActive = item.classList.contains("active");
            section.querySelectorAll(".faq-item").forEach((otherItem) => {
              if (otherItem !== item) {
                otherItem.classList.remove("active");
                otherItem.querySelector(".faq-header").setAttribute("aria-expanded", "false");
                otherItem.querySelector(".faq-content").style.maxHeight = "0px";
              }
            });
            if (isActive) {
              item.classList.remove("active");
              header.setAttribute("aria-expanded", "false");
              content.style.maxHeight = "0px";
            } else {
              item.classList.add("active");
              header.setAttribute("aria-expanded", "true");
              content.style.maxHeight = `${content.scrollHeight}px`;
            }
          });
        }
      };
    }
  });

  // Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/main.js
  var require_main = __commonJS({
    "Desktop/Antigravity/MR Website/Final Backup/full-storefront/js/main.js"() {
      init_cart();
      init_tabs();
      init_faq();
      init_animations();
      init_products();
      window.AppState = {
        activeProduct: "pickupBottle",
        selectedBundleIndex: 1,
        cart: {
          items: [],
          isOpen: false
        },
        theme: {
          accentColor: "#D8B369"
        },
        animationsEnabled: true,
        viewport: {
          isMobile: window.innerWidth < 768
        }
      };
      document.addEventListener("DOMContentLoaded", () => {
        Cart.init();
        AnimationsManager.init();
        FAQManager.init();
        const urlParams = new URLSearchParams(window.location.search);
        const targetProduct = urlParams.get("product");
        if (targetProduct && products[targetProduct]) {
          TabManager.switchProduct(targetProduct);
          document.querySelectorAll(".switch-pill").forEach((btn) => {
            if (btn.getAttribute("data-product") === targetProduct) {
              btn.classList.add("active");
            } else {
              btn.classList.remove("active");
            }
          });
        } else {
          TabManager.switchProduct("pickupBottle");
        }
        document.querySelectorAll(".switch-pill").forEach((btn) => {
          btn.addEventListener("click", () => {
            document.querySelectorAll(".switch-pill").forEach((b) => b.classList.remove("active"));
            btn.classList.add("active");
            const productKey = btn.getAttribute("data-product");
            TabManager.switchProduct(productKey);
          });
        });
        document.querySelectorAll(".ingredients-section .product-btn").forEach((btn) => {
          btn.addEventListener("click", () => {
            const productKey = btn.getAttribute("data-product");
            TabManager.switchProduct(productKey);
          });
        });
        setupCartUI();
        setupBuyCTAs();
        setupScrollHooks();
        window.addEventListener("resize", () => {
          window.AppState.viewport.isMobile = window.innerWidth < 768;
        });
        setupTrustTooltips();
        setTimeout(() => {
          const loader = document.getElementById("loading-screen");
          if (loader) {
            loader.classList.add("fade-out");
            setTimeout(() => {
              loader.style.display = "none";
              document.body.style.overflow = "auto";
            }, 1800);
          }
        }, 2800);
      });
      function renderCartDrawer(cartState) {
        const badge = document.querySelector(".cart-count");
        if (badge) {
          badge.textContent = cartState.item_count;
          badge.style.display = cartState.item_count > 0 ? "flex" : "none";
        }
        const list = document.querySelector('[data-slot="cart-items-list"]');
        if (!list) return;
        list.innerHTML = "";
        if (cartState.items.length === 0) {
          list.innerHTML = `<div class="cart-empty-message">Your shopping cart is currently empty.</div>`;
          document.querySelector('[data-slot="cart-summary-total"]').textContent = "\u20B90";
          return;
        }
        cartState.items.forEach((item) => {
          const itemHtml = `
      <div class="cart-item">
        <img class="cart-item-img" src="${item.image}" alt="${item.title}">
        <div class="cart-item-details">
          <h4 class="cart-item-name">${item.title}</h4>
          <span class="cart-item-meta">${item.variantLabel}</span>
          <div class="cart-item-bottom">
            <div class="quantity-controls">
              <button class="qty-btn" data-action="decrease" data-id="${item.id}">-</button>
              <span class="qty-val">${item.quantity}</span>
              <button class="qty-btn" data-action="increase" data-id="${item.id}">+</button>
            </div>
            <span class="cart-item-price">\u20B9${(item.price * item.quantity).toLocaleString()}</span>
          </div>
        </div>
        <button class="cart-item-remove" data-id="${item.id}" aria-label="Remove item">
          <svg class="cart-remove-icon" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
      </div>
    `;
          list.insertAdjacentHTML("beforeend", itemHtml);
        });
        document.querySelector('[data-slot="cart-summary-total"]').textContent = `\u20B9${cartState.total_price.toLocaleString()}`;
        list.querySelectorAll(".qty-btn").forEach((btn) => {
          btn.addEventListener("click", () => {
            const action = btn.getAttribute("data-action");
            const id = btn.getAttribute("data-id");
            const item = cartState.items.find((i) => i.id === id);
            if (!item) return;
            const newQty = action === "increase" ? item.quantity + 1 : item.quantity - 1;
            Cart.update(id, newQty);
          });
        });
        list.querySelectorAll(".cart-item-remove").forEach((btn) => {
          btn.addEventListener("click", () => {
            const id = btn.getAttribute("data-id");
            Cart.remove(id);
          });
        });
      }
      function setupCartUI() {
        const trigger = document.getElementById("cart-trigger-btn");
        const overlay = document.getElementById("cart-overlay");
        const close = document.getElementById("cart-close-btn");
        const checkoutBtn = document.getElementById("checkout-cta-btn");
        if (trigger) trigger.addEventListener("click", () => Cart.openDrawer());
        if (close) close.addEventListener("click", () => Cart.closeDrawer());
        if (overlay) {
          overlay.addEventListener("click", (e) => {
            if (e.target === overlay) Cart.closeDrawer();
          });
        }
        if (checkoutBtn) {
          checkoutBtn.addEventListener("click", () => Cart.checkout());
        }
        Cart.subscribe(renderCartDrawer);
      }
      function setupBuyCTAs() {
        const buyBtn = document.getElementById("buy-block-cta-btn");
        if (buyBtn) {
          buyBtn.addEventListener("click", () => {
            const activeKey = window.AppState.activeProduct;
            const product = products[activeKey];
            buyBtn.classList.add("adding");
            buyBtn.textContent = "Adding to Cart...";
            setTimeout(() => {
              Cart.add(product, window.AppState.selectedBundleIndex);
              showToastNotification(`${product.name} added to cart!`);
              buyBtn.classList.remove("adding");
              buyBtn.textContent = "Added \u2713";
              setTimeout(() => {
                buyBtn.textContent = "Add to Secure Cart";
              }, 1500);
            }, 700);
          });
        }
        const stickyBtn = document.getElementById("sticky-buy-bar-btn");
        if (stickyBtn) {
          stickyBtn.addEventListener("click", () => {
            const activeKey = window.AppState.activeProduct;
            const product = products[activeKey];
            stickyBtn.classList.add("adding");
            stickyBtn.textContent = "Adding...";
            setTimeout(() => {
              Cart.add(product, window.AppState.selectedBundleIndex);
              showToastNotification(`${product.name} added to cart!`);
              stickyBtn.classList.remove("adding");
              stickyBtn.textContent = "Added \u2713";
              setTimeout(() => {
                stickyBtn.textContent = "Quick Add";
              }, 1500);
            }, 500);
          });
        }
        const heroBtn = document.getElementById("hero-cta-btn");
        if (heroBtn) {
          heroBtn.addEventListener("click", (e) => {
            e.preventDefault();
            const buyBlock = document.getElementById("buy-block");
            if (buyBlock) {
              buyBlock.scrollIntoView({ behavior: "smooth" });
            }
          });
        }
      }
      function setupScrollHooks() {
        const header = document.getElementById("nav-header");
        const stickyBuyBar = document.getElementById("sticky-buy-bar");
        window.addEventListener("scroll", () => {
          const scrollY = window.scrollY;
          if (scrollY > 50) {
            header.classList.add("scrolled");
          } else {
            header.classList.remove("scrolled");
          }
          if (stickyBuyBar) {
            if (scrollY > 550) {
              stickyBuyBar.classList.add("visible");
            } else {
              stickyBuyBar.classList.remove("visible");
            }
          }
        });
      }
      function showToastNotification(message) {
        const container = document.getElementById("toast-container");
        if (!container) return;
        const toast = document.createElement("div");
        toast.className = "toast";
        toast.innerHTML = `
    <svg class="toast-success-icon" viewBox="0 0 24 24"><path d="M20 6L9 17L4 12" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>
    <span>${message}</span>
  `;
        container.appendChild(toast);
        setTimeout(() => toast.classList.add("show"), 50);
        setTimeout(() => {
          toast.classList.remove("show");
          setTimeout(() => toast.remove(), 400);
        }, 3e3);
      }
      function setupTrustTooltips() {
        const strip = document.getElementById("trust-strip");
        if (!strip) return;
        const items = strip.querySelectorAll(".trust-item");
        const tooltip = document.getElementById("trust-tooltip");
        const content = document.getElementById("trust-tooltip-content");
        const closeBtn = document.getElementById("trust-tooltip-close");
        const arrow = document.getElementById("trust-tooltip-arrow");
        const container = strip.querySelector(".container");
        if (!tooltip || !content || !container) return;
        const detailsData = {
          ayurvedic: {
            title: "Ayurvedic Certified",
            text: "Certified by the Ministry of AYUSH. Formulated with 100% pure botanical extracts, free of synthetic additives, heavy metals, or steroids."
          },
          tested: {
            title: "NABL Lab Tested",
            text: "Tested by independent NABL-accredited laboratories to guarantee absolute purity, potency, and safety in every production batch."
          },
          gmp: {
            title: "WHO-GMP Certified",
            text: "Manufactured in WHO-GMP certified facilities, enforcing the highest global pharmaceutical-grade safety and quality protocols."
          },
          shipping: {
            title: "Express Shipping",
            text: "Dispatched from our nearest hub within 24 hours. Includes free shipping on bundles and live SMS tracking to your doorstep."
          }
        };
        items.forEach((item, index) => {
          item.addEventListener("click", (e) => {
            const keys = ["ayurvedic", "tested", "gmp", "shipping"];
            const key = keys[index];
            const data = detailsData[key];
            if (item.classList.contains("active-detail")) {
              closeTooltip();
              return;
            }
            items.forEach((i) => i.classList.remove("active-detail"));
            item.classList.add("active-detail");
            content.innerHTML = `
        <div class="trust-tooltip-title">${data.title}</div>
        <div>${data.text}</div>
      `;
            const itemRect = item.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            const iconCenter = itemRect.left - containerRect.left + itemRect.width / 2;
            if (window.innerWidth < 768) {
              tooltip.style.left = "50%";
              tooltip.style.transform = "translate(-50%, 0)";
              const tooltipWidth = 320;
              const containerWidth = containerRect.width;
              let arrowLeft = tooltipWidth / 2 + (iconCenter - containerWidth / 2);
              arrowLeft = Math.max(25, Math.min(tooltipWidth - 25, arrowLeft));
              arrow.style.left = `${arrowLeft}px`;
            } else {
              tooltip.style.left = `${iconCenter}px`;
              tooltip.style.transform = "translate(-50%, 0)";
              arrow.style.left = "50%";
            }
            tooltip.classList.add("active");
          });
        });
        function closeTooltip() {
          tooltip.classList.remove("active");
          items.forEach((i) => i.classList.remove("active-detail"));
        }
        if (closeBtn) {
          closeBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            closeTooltip();
          });
        }
        document.addEventListener("click", (e) => {
          if (!strip.contains(e.target)) {
            closeTooltip();
          }
        });
      }
      var stickerQty = 0;
      var stickerUnitPrice = 799;
      window.activateStickerCart = function() {
        stickerQty = 1;
        const pillMain = document.getElementById("pillMain");
        if (pillMain) pillMain.classList.add("active-cart");
        window.updateStickerDisplay();
        const product = products["pickupBottle"];
        if (product) Cart.add(product, 0, 1);
      };
      window.updateStickerQty = function(change) {
        stickerQty += change;
        const pillMain = document.getElementById("pillMain");
        if (stickerQty <= 0) {
          stickerQty = 0;
          if (pillMain) pillMain.classList.remove("active-cart");
        } else {
          window.updateStickerDisplay();
          const product = products["pickupBottle"];
          if (product && change > 0) Cart.add(product, 0, 1);
        }
      };
      window.selectStickerBundle = function(bundleQty, price) {
        stickerQty = bundleQty;
        stickerUnitPrice = Math.round(price / bundleQty);
        const pillMain = document.getElementById("pillMain");
        if (pillMain) pillMain.classList.add("active-cart");
        window.updateStickerDisplay();
        const product = products["pickupBottle"];
        const pkgIdx = Math.min(bundleQty - 1, 2);
        if (product) Cart.add(product, pkgIdx, 1);
      };
      window.updateStickerDisplay = function() {
        const qtyCount = document.getElementById("qtyCount");
        const capsulePrice = document.getElementById("capsulePrice");
        if (qtyCount) qtyCount.innerText = stickerQty;
        if (capsulePrice) capsulePrice.innerText = "\u20B9" + (stickerQty * stickerUnitPrice).toLocaleString("en-IN");
      };
    }
  });
  require_main();
})();

;
// Reels Carousel JavaScript extracted from test.html
const reels = [
  { id: 1, user: "@devansh_kapoor", tagline: "My 60‑day review of Shilajit", video: "https://player.vimeo.com/external/371433846.sd.mp4?s=236da2f3c0227ee0d20d4374ca2996d9c6cfba37&profile_id=139&oauth2_token_id=57447761" },
  { id: 2, user: "@kunal_fitness", tagline: "Hair Zero Cream test", video: "https://player.vimeo.com/external/435674703.sd.mp4?s=7fdf702c2e9b0b4b2fb418a096c4b267104d496a&profile_id=165&oauth2_token_id=57447761" },
  { id: 3, user: "@ayush_travels", tagline: "Pocket Blister review", video: "https://player.vimeo.com/external/384761655.sd.mp4?s=3824edab3de2c2a048a1c97a2df252579dfd9e4c&profile_id=165&oauth2_token_id=57447761" },
  { id: 4, user: "@rahul_gupta", tagline: "Boosted gym endurance", video: "https://player.vimeo.com/external/517602126.sd.mp4?s=d740c01da0d1702f2329388df638971f11467cc7&profile_id=165&oauth2_token_id=57447761" },
  { id: 5, user: "@sid_hacks", tagline: "Pure botanical formulation", video: "https://player.vimeo.com/external/403848972.sd.mp4?s=80387532d847bdeec7369f64fa3fb1e7c00e1cc7&profile_id=165&oauth2_token_id=57447761" },
  { id: 6, user: "@devansh_kapoor", tagline: "My 60‑day review of Shilajit", video: "https://player.vimeo.com/external/371433846.sd.mp4?s=236da2f3c0227ee0d20d4374ca2996d9c6cfba37&profile_id=139&oauth2_token_id=57447761" }
];

const muteIcon = `<svg viewBox="0 0 24 24"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>`;
const soundIcon = `<svg viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>`;

const list = document.getElementById('reel-list');
const modal = document.getElementById('reel-modal');
const modalBody = document.getElementById('modal-body');
let currentReelIndex = 0;

reels.forEach((r, index) => {
  const card = document.createElement('div');
  card.className = 'reel-card';
  card.setAttribute('tabindex', '0');
  card.setAttribute('aria-label', `Watch reel ${r.id} by ${r.user}`);

  const vid = document.createElement('video');
  vid.src = r.video;
  vid.autoplay = true;
  vid.muted = true;
  vid.loop = true;
  vid.playsInline = true;

  vid.addEventListener('loadeddata', () => {
    vid.style.opacity = '1';
    card.style.animation = 'none';
  });

  const audioBadge = document.createElement('div');
  audioBadge.className = 'audio-badge';
  audioBadge.innerHTML = muteIcon;

  const info = document.createElement('div');
  info.className = 'reel-info';
  info.innerHTML = `<div class="reel-user">${r.user}</div><div class="reel-tagline">${r.tagline}</div>`;

  card.appendChild(vid);
  card.appendChild(audioBadge);
  card.appendChild(info);
  list.appendChild(card);

  card.addEventListener('mouseenter', () => {
    if (!modal.classList.contains('active')) {
      vid.muted = false;
      audioBadge.innerHTML = soundIcon;
    }
  });
  card.addEventListener('mouseleave', () => {
    vid.muted = true;
    audioBadge.innerHTML = muteIcon;
  });

  const triggerModal = () => {
    vid.muted = true;
    audioBadge.innerHTML = muteIcon;
    openModal(index);
  };

  card.addEventListener('click', triggerModal);
  card.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') { e.preventDefault(); triggerModal(); }
  });
});

function renderModalVideo() {
  const reel = reels[currentReelIndex];
  modalBody.innerHTML = `<video src="${reel.video}" autoplay loop controls playsinline></video>
    <div class="reel-info">
      <div class="reel-user">${reel.user}</div>
      <div class="reel-tagline">${reel.tagline}</div>
    </div>`;
}
function openModal(index) {
  currentReelIndex = index;
  renderModalVideo();
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';
}
function closeModal() {
  modal.classList.remove('active');
  modalBody.innerHTML = '';
  document.body.style.overflow = '';
}
function nextReel() { currentReelIndex = (currentReelIndex + 1) % reels.length; renderModalVideo(); }
function prevReel() { currentReelIndex = (currentReelIndex - 1 + reels.length) % reels.length; renderModalVideo(); }

document.getElementById('close-modal').addEventListener('click', closeModal);
document.getElementById('modal-next').addEventListener('click', nextReel);
document.getElementById('modal-prev').addEventListener('click', prevReel);

modal.addEventListener('click', (e) => {
  if (e.target === modal) closeModal();
});

document.addEventListener('keydown', (e) => {
  if (!modal.classList.contains('active')) return;
  if (e.key === 'Escape') closeModal();
  if (e.key === 'ArrowRight') nextReel();
  if (e.key === 'ArrowLeft') prevReel();
});
